import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, placeOwnersUrl: String }

  filterCategories(event) {
    const retailerId = event.target.value
    const selectedCategoryId = document.getElementById("planogram_retailer_category_id")?.value || ""
    const selectedPlaceOwnerId = document.getElementById("planogram_place_owner_id")?.value || ""

    // Update categories
    const categoryUrl = new URL(this.urlValue, window.location.origin)
    categoryUrl.searchParams.set("retailer_id", retailerId)
    categoryUrl.searchParams.set("selected_id", selectedCategoryId)
    const categoryFrame = document.getElementById("planogram_category_select")
    if (categoryFrame) categoryFrame.src = categoryUrl.toString()

    // Update place owners
    if (this.hasPlaceOwnersUrlValue) {
      const poUrl = new URL(this.placeOwnersUrlValue, window.location.origin)
      poUrl.searchParams.set("retailer_id", retailerId)
      poUrl.searchParams.set("selected_id", selectedPlaceOwnerId)
      const poFrame = document.getElementById("planogram_place_owner_select")
      if (poFrame) poFrame.src = poUrl.toString()
    }
  }
}
